export default function SectionEyebrow({ label, title, description, align = "left" }) {
  const cls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${cls}`} data-motion-heading>
      <div className="eyebrow" data-motion-label>{label}</div>
      <h2 className="h2 mt-4" data-motion-title>{title}</h2>
      {description && <p className="body-lg mt-5" data-motion-description>{description}</p>}
    </div>
  );
}
